import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";
import { callAPI } from "../utils/apiUtils";
import { apiUrls } from "../utils/apiUrls";

const firebaseConfig = {
    apiKey: "AIzaSyASlzI7eXpNNcysQWIQN4MsuGZN3_A7ZAQ",
    authDomain: "komutan-fb984.firebaseapp.com",
    projectId: "komutan-fb984",
    storageBucket: "komutan-fb984.firebasestorage.app",
    messagingSenderId: "126066050255",
    appId: "1:126066050255:web:d78f69e7c2a83afc36a3ba",
    measurementId: "G-PTYYKPW8MB"

};

const app = initializeApp(firebaseConfig);

export const registerFcmToken = async () => {
    try {
        if (!(await isSupported())) return;
        if (Notification.permission === "default") await Notification.requestPermission();
        if (Notification.permission !== "granted") return;

        const swReg = await navigator.serviceWorker.register("/firebase-messaging-sw.js");
        const token = await getToken(getMessaging(app), {
            vapidKey: "BALjdLNlPOmz_vRwRhF9jGzrL6FJ-wS6P5lGrKSUGUt-DWliAoWZjYR3oIxb4VILToiaYEYjPocFlhus0YDgFWo",
            serviceWorkerRegistration: swReg,
        });
        if (!token) return;

        localStorage.setItem("fcmToken", token);
        await callAPI(apiUrls.fcmToken, {}, "POST", { fcmToken: token });
    } catch (e) {
        console.error("FCM register failed", e);
    }
};

export const removeFcmToken = async () => {
    const token = localStorage.getItem("fcmToken");
    if (!token) return;
    try {
        await callAPI(apiUrls.fcmToken, {}, "DELETE", { fcmToken: token });
    } catch (e) {
        console.error("FCM remove failed", e);
    }
    localStorage.removeItem("fcmToken");
};

export const onForegroundMessage = async (cb) => {
    if (!(await isSupported())) return () => { };
    return onMessage(getMessaging(app), cb);
};